import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { TrophyComponent } from '../../../components/trophy/trophy';
import { LoaderProvider } from '../../../providers/loader/loader';
import { ResultListModel, ResultProvider, TrophyColor, TrophyMaterial, TrophyType } from '../../../providers/result/result';

/**
 * Generated class for the ResultEditTrophyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-result-edit-trophy',
  templateUrl: 'result-edit-trophy.html',
})
export class ResultEditTrophyPage {

  @ViewChild("trophy")
  trophyComponent: TrophyComponent;

  resultBackup: ResultListModel;

  types: TrophyType[] = [];
  selectedType: TrophyType;

  colors: TrophyColor[] = [];
  selectedColor: TrophyColor;

  materials: TrophyMaterial[];
  selectedMaterial: TrophyMaterial;

  result: ResultListModel;
  anotherType = false;
  hideOthers = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private resultService: ResultProvider,
    private app: App,
    public translate: TranslateService,
    private loadingCtrl: LoaderProvider
  ) {
    this.types = navParams.data.data.types;
    this.colors = navParams.data.data.colors;
    this.materials = navParams.data.data.materials;

    this.resultBackup = navParams.data.data.result;

    this.result = JSON.parse(JSON.stringify(navParams.data.data.result));

    // this.result.hasDatum = !this.result.hasDatum;
    // this.result.hasPlatz = !this.result.hasPlatz;
    // this.result.hasStrecke = !this.result.hasStrecke;
    // this.result.hasZeit = !this.result.hasZeit;

    this.selectedType = this.types.find(x => x.modelName === this.result.trophyType);
    this.selectedColor = this.colors.find(x => x.id === parseInt(this.result.trophyColor));
    this.selectedMaterial = this.materials.find(x => x.id === parseInt(this.result.trophyMaterial));
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResultEditTrophyPage');
  }

  selectType(type: TrophyType) {
    this.selectedType = type;
    this.result.trophyType = this.selectedType.modelName;
    this.updateTrophy();
  }

  selectColor(color: TrophyColor) {
    this.selectedColor = color;
    this.result.trophyColor = color.id + "";
    this.updateTrophy();
  }

  selectMaterial(material: TrophyMaterial) {
    this.selectedMaterial = material;
    this.result.trophyMaterial = material.id + "";
    this.updateTrophy();
  }

  updateTrophy(type?: any) {
    this.hideOthers = this.selectedType && this.selectedType.name === 'certificatePapyrus';
    // this.anotherType = this.selectedType && this.selectedType.name ==='LasVegas';
    // this.trophyComponent.switch(this.result);
    
  }

  ionViewWillLeave() {
    // this.trophyComponent.ionViewWillLeave();
  }
  ionViewWillEnter() {
    // this.trophyComponent.ngAfterViewInit();
  }

  save() {
    console.log('save()')
    let loading = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loading.present();

    this.resultService.updateTrophy({
      hasDatum: !this.result.hasDatum,
      hasPlatz: !this.result.hasPlatz,
      hasStrecke: !this.result.hasStrecke,
      hasZeit: !this.result.hasZeit,
      resultId: this.result.id,
      trophyColor: parseInt(this.result.trophyColor),
      trophyMaterial: parseInt(this.result.trophyMaterial),
      trophyType: this.result.trophyType
    }).then((succ) => {
      if (succ) {
        this.resultBackup.hasDatum = this.result.hasDatum;
        this.resultBackup.hasPlatz = this.result.hasPlatz;
        this.resultBackup.hasStrecke = this.result.hasStrecke;
        this.resultBackup.hasZeit = this.result.hasZeit;
        this.resultBackup.trophyColor = this.result.trophyColor;
        this.resultBackup.trophyMaterial = this.result.trophyMaterial;
        this.resultBackup.trophyType = this.result.trophyType;
        this.navCtrl.pop().then(() => loading.dismiss());
      } else {
        loading.dismiss();
      }
    });

  }
}



// WEBPACK FOOTER //
// /src/pages/results/result-edit-trophy/result-edit-trophy.ts